import EmberRouter from '@ember/routing/router';

import config from 'umg-ember-backend/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('login');

  this.route('admin', { path: '/' }, function () {
    this.route('a11y-quickscan');

    this.route('a11y-reports', function () {
      this.route('a11y-report', { path: ':a11y_report_id' });
    });

    this.route('a11y-scanners', function () {
      this.route('new');
      this.route('a11y-scanner', { path: ':a11y_scanner_id' });
    });

    this.route('actions', function () {
      this.route('new');
      this.route('action', { path: ':action_id' });
    });

    this.route('articles', function () {
      this.route('new');
      this.route('article', { path: ':article_id' });
    });

    this.route('artists', function () {
      this.route('new');
      this.route('artist', { path: ':artist_id' });
    });

    this.route('assets', function () {
      this.route('new');
      this.route('asset', { path: ':asset_id' });
    });

    this.route('asset-formats', function () {
      this.route('new');
      this.route('asset-format', { path: ':asset_format_id' });
    });

    this.route('asset-token-configs', function () {
      this.route('index', { path: '/' });
      this.route('new');
      this.route('asset-token-config', { path: ':asset_token_config_id' });
    });

    this.route('audioplayers', function () {
      this.route('new');
      this.route('audioplayer', { path: ':audioplayer_id' });
    });

    this.route('calendar-events', function () {
      this.route('new');
      this.route('calendar-event', { path: ':calendar_event_id' });
    });

    this.route('categories', function () {
      this.route('new');
      this.route('category', { path: ':category_id' });
    });

    this.route('channels', function () {
      this.route('channel', { path: ':channel_id' });
      this.route('new');
    });

    this.route('collections', function () {
      this.route('new');
      this.route('collection', { path: ':collection_id' });
    });

    this.route('coop-partners', function () {
      this.route('new');
      this.route('coop-partner', { path: ':coop_partner_id' });
    });

    this.route('dashboard', { path: '/' });

    this.route('digital-order-configs', function () {
      this.route('new');
      this.route('digital-order-config', { path: ':digital_order_config_id' });
    });

    this.route('divisions', function () {
      this.route('new');
      this.route('division', { path: ':division_id' });
    });

    this.route('domains', function () {
      this.route('new');
      this.route('domain', { path: ':domain_id' });
    });

    this.route('error', { path: 'error/:error' });

    this.route('frontend-users', function () {
      this.route('new');
      this.route('frontend-user', { path: ':frontend_user_id' });
    });

    this.route('jobs', function () {
      this.route('new');
      this.route('job', { path: ':job_id' });
    });

    this.route('labels', function () {
      this.route('new');
      this.route('label', { path: ':label_id' });
    });

    this.route('locations', function () {
      this.route('new');
      this.route('location', { path: ':location_id' });
    });

    this.route('links', function () {
      this.route('new');
      this.route('link', { path: ':link_id' });
    });

    this.route('link-patterns', function () {
      this.route('new');
      this.route('link-pattern', { path: ':link_pattern_id' });
    });

    this.route('live-events', function () {
      this.route('new');
      this.route('live-event', { path: ':live_event_id' });
    });

    this.route('live-partners', function () {
      this.route('new');
      this.route('live-partner', { path: ':live_partner_id' });
    });

    this.route('media-embeds', function () {
      this.route('new');
      this.route('media-embed', { path: ':media_embed_id' });
    });

    this.route('media-events', function () {
      this.route('new');
      this.route('media-event', { path: ':media_event_id' });
    });

    this.route('media-partners', function () {
      this.route('new');
      this.route('media-partner', { path: ':media_partner_id' });
    });

    this.route('newsletter-configs', function () {
      this.route('new');
      this.route('newsletter-config', { path: ':newsletter_config_id' });
    });

    this.route('newsletter-targets', function () {
      this.route('newsletter-target', { path: ':newsletter_target_id' });
    });

    this.route('newsletters', function () {
      this.route('new');
      this.route('newsletter', { path: ':newsletter_id' });
    });

    this.route('organizations', function () {
      this.route('new');
      this.route('organization', { path: ':organization_id' });
    });

    this.route('people', function () {
      this.route('person', { path: ':person_id' });
      this.route('new');
    });

    this.route('products', function () {
      this.route('new');
      this.route('product', { path: ':product_id' });
    });

    this.route('product-elements', function () {
      this.route('new');
      this.route('product-element', { path: ':product_element_id' });
    });

    this.route('product-families', function () {
      this.route('new');
      this.route('product-family', { path: ':product_family_id' });
    });

    this.route('product-tracks', function () {
      this.route('new');
      this.route('product-track', { path: ':product_track_id' });
    });

    this.route('product-works', function () {
      this.route('new');
      this.route('product-work', { path: ':product_work_id' });
    });

    this.route('profile');

    this.route('sections', function () {
      this.route('new');
      this.route('section', { path: ':section_id' });
    });

    this.route('sftp-users', function () {
      this.route('new');
      this.route('sftp-user', { path: ':sftp_user_id' });
    });

    this.route('contests', function () {
      this.route('new');
      this.route('contest', { path: ':contest_id' });
    });

    this.route('contest-entries', function () {
      this.route('new');
      this.route('contest-entry', { path: ':contest_entry_id' });
    });

    this.route('shopify-stores', function () {
      this.route('new');
      this.route('shopify-store', { path: ':shopify_store_id' });
    });

    this.route('short-urls', function () {
      this.route('new');
      this.route('short-url', { path: ':short_url_id' });
    });

    this.route('sign-out');

    this.route('stories', function () {
      this.route('new');
      this.route('story', { path: ':story_id' });
    });

    this.route('taxa', function () {
      this.route('index', { path: '/' });
      this.route('new');
      this.route('taxon', { path: ':taxon_id' });
    });

    this.route('taxonomies', function () {
      this.route('index', { path: '/' });
      this.route('new');
      this.route('taxonomy', { path: ':taxonomy_id' });
    });

    this.route('teasers', function () {
      this.route('new');
      this.route('teaser', { path: ':teaser_id' });
    });

    this.route('tool-itunes-import');
    this.route('tool-merge-artists');
    this.route('tool-mmc-importer');
    this.route('tool-reset-voucher');
    this.route('tool-itunes-ids-uploader');

    this.route('trade-partners', function () {
      this.route('new');
      this.route('trade-partner', { path: ':trade_partner_id' });
    });

    this.route('url-aliases', function () {
      this.route('new');
      this.route('url-alias', { path: ':url_alias_id' });
    });

    this.route('mlps', function () {
      this.route('new');
      this.route('mlp', { path: ':mlp_id' });
    });

    this.route('users', function () {
      this.route('new');
      this.route('user', { path: ':user_id' });
    });

    this.route('user-roles', function () {
      this.route('new');
      this.route('user-role', { path: ':user_role_id' });
    });

    this.route('vhosts', function () {
      this.route('new');
      this.route('vhost', { path: ':vhost_id' });
    });

    this.route('web-series', function () {
      this.route('new');
      this.route('web-series', { path: ':web_series_id' });
    });
  });

  this.route('error', { path: '/*path' }); // denied|404
});
